import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Briefcase } from "lucide-react";

const FALLBACK_GOOGLE_CLIENT_ID =
  "214420186699-ucrnjs353m7n85m0q90q6iqnja866511.apps.googleusercontent.com";

export default function Login() {
  const googleButtonRef = useRef(null);
  const [erro, setErro] = useState("");
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || FALLBACK_GOOGLE_CLIENT_ID;

    const handleCredentialResponse = async (googleResponse) => {
      try {
        setCarregando(true);
        setErro("");
        const remoteBackend = process.env.REACT_APP_BACKEND_URL?.replace(/\/$/, "");
        const authUrl = process.env.NODE_ENV === "development" && remoteBackend
          ? `${remoteBackend}/api/auth/google`
          : "/api/auth/google";

        const response = await fetch(authUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ credential: googleResponse.credential }),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data?.detail || data?.message || "Não foi possível entrar com Google.");
        if (data.role === "admin") {
          window.location.href = "/admin";
          return;
        }
        window.location.href = "/empresa";
      } catch (error) {
        console.error("Erro no Login Google:", error);
        setErro(error.message || "Não foi possível entrar com sua conta Google.");
        setCarregando(false);
      }
    };

    const iniciarGoogle = () => {
      if (!window.google || !googleButtonRef.current) return;
      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: handleCredentialResponse,
        ux_mode: "popup",
        auto_select: false,
        cancel_on_tap_outside: true,
      });
      googleButtonRef.current.innerHTML = "";
      window.google.accounts.id.renderButton(googleButtonRef.current, {
        type: "standard",
        theme: "outline",
        size: "large",
        text: "continue_with",
        shape: "rectangular",
        logo_alignment: "left",
        width: 350,
        locale: "pt-BR",
      });
    };

    if (window.google?.accounts?.id) {
      iniciarGoogle();
      return;
    }

    let script = document.querySelector('script[src="https://accounts.google.com/gsi/client"]');
    if (!script) {
      script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
    script.addEventListener("load", iniciarGoogle);
    return () => script?.removeEventListener("load", iniciarGoogle);
  }, []);

  return (
    <div className="min-h-[calc(100vh-70px)] grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-center bg-gradient-to-r from-blue-700 to-indigo-900 text-white grain p-16">
        <h2 className="font-heading text-4xl font-extrabold tracking-tight leading-tight">Sua empresa contratando na<br />Região de Campinas</h2>
        <p className="mt-5 text-blue-100 text-lg max-w-md leading-relaxed">Publique vagas, receba candidatos direto no WhatsApp e gerencie tudo em um painel simples.</p>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-md bg-white rounded-3xl p-10 border border-slate-200 shadow-[0_8px_32px_rgba(0,0,0,0.04)]">
          <span className="bg-gradient-to-r from-blue-700 to-indigo-900 text-white w-12 h-12 rounded-2xl grid place-items-center mb-6"><Briefcase size={22} /></span>
          <h1 className="font-heading text-2xl font-extrabold tracking-tight text-slate-950">Entrar / Criar conta de empresa</h1>
          <p className="text-slate-600 mt-2 leading-relaxed">Acesse com sua conta Google para cadastrar sua empresa e publicar vagas. Candidatos não precisam de conta.</p>

          <div className="mt-8">
            <div ref={googleButtonRef} className="flex justify-center min-h-[44px]" data-testid="google-login-button" />
            {carregando && <p className="text-center text-sm text-slate-500 mt-4">Entrando...</p>}
            {erro && <div className="mt-4 rounded-xl bg-red-50 border border-red-200 p-3 text-sm text-red-700">{erro}</div>}
          </div>

          <p className="text-slate-500 text-sm mt-6 text-center leading-relaxed">
            Ao continuar, você concorda com os <Link to="/termos" className="text-blue-700 font-bold hover:underline">Termos de Uso</Link> e declara que leu a <Link to="/privacidade" className="text-blue-700 font-bold hover:underline">Política de Privacidade</Link>. Empresas devem anunciar apenas vagas reais e verdadeiras.
          </p>
        </div>
      </div>
    </div>
  );
}
